export const coreFlightCfarOffersThemeVars = (colors?: {
  nonRefundableInfoBarIconColor?: string;
  nonRefundableInfoBarBackgroundColor?: string;
}) => ({
  "core-cfar-flights-non-refundable-info-bar-icon-color":
    colors?.nonRefundableInfoBarIconColor ?? "#F1F1F1",
  "core-cfar-flights-non-refundable-info-bar-background-color":
    colors?.nonRefundableInfoBarBackgroundColor ?? "#F1F1F1",
});
